<template>
    <div class= "dashboard-arrow">
        <div class="circle-container">
            <router-link v-if="isInternal" v-bind:to="link" class="link">
            <div class="arrow-circle"></div>
                <span class="arrow-svg-container">
                    <diagonal-arrow-svg></diagonal-arrow-svg>
                </span>
            </router-link>
            <a v-else :href="link" class="link" target="_blank">
            <div class="arrow-circle"></div>
                <span class="arrow-svg-container">
                    <diagonal-arrow-svg></diagonal-arrow-svg>
                </span> 
            </a>
        </div>
    </div>
</template>

<script>
import DiagonalArrowSvg from '@/components/svg/diagonal-arrow-svg';

export default {
    props: ['link', 'isInternal'],

    components: {
        'diagonal-arrow-svg': DiagonalArrowSvg,
    }
}
</script>

<style>
.dashboard-arrow .circle-container a {
    display: inline-block;
    width: 100%;
    height: 40px;
    transform: scale(1);
}

.dashboard-arrow .circle-container .arrow-circle {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    top: -34px;
    left: 18px;
    position: absolute;
}

.dashboard-arrow .circle-container {
    width: 60px;
    position: absolute;
    right: 0;
    top: 0;
}

.dashboard-arrow .link .arrow-circle {
    background: #D2C7FE;
    z-index: -1;
    transition: all 0.2s ease-in-out;
    transform: scale(0);
}

.dashboard-arrow .link:hover .arrow-circle {
    transform: scale(1);
}

.dashboard-arrow .link:hover .arrow-svg-container line {
    stroke: #fff;
    transition: all 0.4s ease-in-out;
}

.dashboard-arrow .circle-container .arrow-circle::before {
    display: none;
}

.dashboard-arrow .arrow-svg-container svg {
    height: 21px;
    right: -38px;
    position: relative;
    top: 2px;
}

.dashboard-arrow .arrow-svg-container line {
    stroke: #877D88;
    transition: all 0.4s ease-in-out;
    opacity: inherit;
}
</style>